import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ApPersistenceService {
    public getLocal(key: string, property: string): any {
        return this.getFromStorage(window.localStorage, key)[property];
    }

    public setLocal(key: string, property: string, value: any): void {
        const data: any = this.getFromStorage(window.localStorage, key);
        data[property] = value;
        try {
            window.localStorage.setItem(key, JSON.stringify(data));
        } catch (e) {
            console.info('localStorage not available');
        }
    }

    public clearLocal(key: string): void {
        try {
            window.localStorage.removeItem(key);
        } catch (e) {
            console.info('localStorage not available');
        }
    }

    public getSession(key: string, property: string): any {
        return this.getFromStorage(window.sessionStorage, key)[property];
    }

    public setSession(key: string, property: string, value: any): void {
        const data: any = this.getFromStorage(window.sessionStorage, key);
        data[property] = value;
        window.sessionStorage.setItem(key, JSON.stringify(data));
    }

    public clearSession(key: string): void {
        try {
            window.sessionStorage.removeItem(key);
        } catch (e) {
            console.info('sessionStorage not available');
        }
    }

    private getFromStorage(storage: Storage, key: string): any {
        let item;
        try {
            item = storage?.getItem(key);
        } catch (e) {
            console.info('localStorage not available');
        }
        if (!item) {
            return {};
        }
        try {
            return JSON.parse(item);
        } catch (Error) {
            return {};
        }
    }
}
